export const EKYCURL = process.env.REACT_APP_PARTNERSIGNUP_API;
export const UPLOADSIZELIMIT: number =
  process.env.REACT_APP_UPLOAD_SIZE_LIMIT !== undefined
    ? parseInt(process.env.REACT_APP_UPLOAD_SIZE_LIMIT)
    : 8;
export const UploadSizes = {
  signature: {
    pdfSize: 2,
    imageSize: 2,
  },
  pancard: {
    pdfSize: 2,
    imageSize: 2,
  },
  gst_proof: {
    pdfSize: 2,
    imageSize: 2,
  },
  incomeproof: {
    pdfSize: 7,
    imageSize: 3,
  },
  bank_proof: {
    pdfSize: 3,
    imageSize: 3,
  },
};

export const REDIRECTURL = process.env.REACT_APP_REDIRECT_URL;